import React from 'react';
import './TrustDashboard.css';

function TrustDashboard() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Trust Dashboard</h1>
        <p className="lead">Real-time trust metrics and analytics dashboard</p>
      </div>
      
      <div className="content-section">
        <div className="row">
          <div className="col-md-3">
            <div className="card metric-card">
              <div className="card-body">
                <div className="metric-icon">
                  <i className="bi bi-shield-check"></i>
                </div>
                <div className="metric-content">
                  <h3>Trust Score</h3>
                  <div className="metric-value">92%</div>
                  <div className="metric-trend positive">
                    <i className="bi bi-arrow-up"></i> 3.2%
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="card metric-card">
              <div className="card-body">
                <div className="metric-icon">
                  <i className="bi bi-graph-up"></i>
                </div>
                <div className="metric-content">
                  <h3>Compliance</h3>
                  <div className="metric-value">88%</div>
                  <div className="metric-trend positive">
                    <i className="bi bi-arrow-up"></i> 2.1%
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="card metric-card">
              <div className="card-body">
                <div className="metric-icon">
                  <i className="bi bi-check-circle"></i>
                </div>
                <div className="metric-content">
                  <h3>Risk Score</h3>
                  <div className="metric-value">Low</div>
                  <div className="metric-trend neutral">
                    <i className="bi bi-dash"></i> Stable
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="card metric-card">
              <div className="card-body">
                <div className="metric-icon">
                  <i className="bi bi-clock-history"></i>
                </div>
                <div className="metric-content">
                  <h3>Uptime</h3>
                  <div className="metric-value">99.9%</div>
                  <div className="metric-trend positive">
                    <i className="bi bi-arrow-up"></i> 0.3%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-8">
            <div className="card">
              <div className="card-body">
                <h4>Trust Metrics Timeline</h4>
                <div className="chart-container">
                  <div className="chart-placeholder">
                    <i className="bi bi-graph-up"></i>
                    <p>Trust metrics visualization over time</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h4>Active Alerts</h4>
                <div className="alerts-list">
                  <div className="alert-item warning">
                    <i className="bi bi-exclamation-triangle"></i>
                    <div className="alert-content">
                      <h5>Compliance Review Required</h5>
                      <p>Due in 3 days</p>
                    </div>
                  </div>
                  <div className="alert-item success">
                    <i className="bi bi-check-circle"></i>
                    <div className="alert-content">
                      <h5>Security Audit Complete</h5>
                      <p>All checks passed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrustDashboard;
